/* unplugin-vue-components disabled */import script from "./TtgView.vue?vue&type=script&setup=true&lang=js"
export * from "./TtgView.vue?vue&type=script&setup=true&lang=js"

import "./TtgView.vue?vue&type=style&index=0&id=1bb5278d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bb5278d"]])

export default __exports__